import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { RowDiv, Text } from 'styles';
import { Aside, Loading, ScrollAside } from 'components';

export function SubLayout({ list, children, nav, setRef }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      if (list) {
        setLoading(false);
      }
    }, 200);
  }, [list]);

  return (
    <Container>
      {(loading && <Loading />) || (
        <>
          <VisualBox $visual={list.visual}>
            <h2>{list.title}</h2>
            <Text $color="primary100" $type="h5" $mType="h7">
              {list.subTitle}
            </Text>
            <Text $type="b6" $mType="b8" $color="white" $whiteSpace="pre" $textAlign="center">
              {list.subText}
            </Text>
          </VisualBox>
          <RowDiv
            $maxWidth={1440}
            $padding="104px 0"
            $tPadding="0"
            $margin="auto"
            $width="100%"
            $gap={32}
            $tGap="0"
            $tFlexDirection="column"
          >
            {(window.location.pathname.includes('community') && <Aside nav={nav} setRef={setRef} />) || (
              <ScrollAside list={nav} setRef={setRef} />
            )}

            {children}
          </RowDiv>
        </>
      )}
    </Container>
  );
}

const Container = styled.div`
  margin-top: 104px;
  min-height: 700px;
  height: 100%;

  @media ${({ theme }) => theme.device.tablet} {
    padding: 0 0 72px 0;
    flex-direction: column;
    gap: 72px;
  }
  @media ${({ theme }) => theme.device.mobile} {
    gap: 48px;
    padding: 0 0 48px 0;
  }
`;

const VisualBox = styled.div`
  position: relative;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 460px;
  min-height: 460px;
  background-image: ${({ $visual }) => $visual && `url(${$visual})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: center;

  h2 {
    font-size: 2.75rem;
    line-height: 1.2;
    color: white;
    margin-bottom: 8px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    height: 400px;
    h2 {
      font-size: 2.375rem;
    }
  }
`;
